// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1alIM","col":"styles_col__SEpSQ"};